
/* eslint-disable default-case */
import React, { useContext, useEffect, useState } from 'react'
import { Route, Switch, useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import ArsDashboard from './ars/ArsDashboard'
import GenericTabsComponent from '../../genericComponents/GenericTabsComponent'
import GenericInput from '../../genericComponents/input/GenericInputComponent'
import Icons from '../../assets/icons'
import { useDispatch, useSelector } from 'react-redux'
import { dispatchHandler } from '../../helper/apiHelperFunctions'
import '../../styles/stylesheets/home/Dashboard.scss'
import SalesOrderDashboard from './salesOrder/SalesOrderDashboard'
import ProcurementDashboard from './procurement/ProcurementDashboard'
import WarehouseAppointmentDashboard from './warehouseAppointment/WarehouseAppointmentDashboard'
import BoxAnalysisDashboard from './boxAnalysis/BoxAnalysisDashboard'
import AsnLifecycleDashboard from './asnLifecycleDashboard/AsnLifecycleDashboard'
import OrderTrackingDashboard from './orderTracking/OrderTrackingDashboard'
import PerformanceSummaryDashboard from './performanceSummary/PerformanceSummary'
import { getNumberOfStrips } from '../../initialPhaseOperations/InitialAnnouncementModal'
import NewRegisterVendorDashbaord from './newVendor/NewRegisterVendorDashbaord'
import { parseJwt } from '../../helper/genericFunction'
import { getEnterprises, getMenuMode } from '../../helper/helperTableFunctions'
import ProcDashboard from './procurement/ProcDashboard'
import { getPermissionKey } from '../../helper/permissions'
import { UserDetailsContext } from '../../App'
import DigicatalogueDashbaord from './digicat/DigicatalogueDashbaord'
import OldProcDashboard from './procurement/oldProcDashboard/OldProcDashboard'
import UserDashboard from './userDashboard/UserDashboard'
import HomeDashboard from '../HomeDashboard'
import { getPayloadFromURLParams, setPayloadAsURLParams } from '../../helper/URLParamsHelper'
import SalesForecastDashboard from './ars/SalesForecastDashboard'
import TNAAnalysis from './tna/TNAAnalysis'
import TNADashboard from './tna/TNADashboard'
import BusinessDashboard from './businessDashboard/BusinessDashboard'

const Dashboard = (props) => {

    const history = useHistory()
    const dispatch = useDispatch()
    const location = useLocation();
    
    const searchParams = new URLSearchParams(location.search);

    let uType = parseJwt(sessionStorage.getItem("token"))?.uType?.toUpperCase();
    let {userDetails, setUserDetails} = useContext(UserDetailsContext)
    
    let getNewMainMenuModulesData = useSelector(state => state?.authStore?.getNewMainMenuModulesData);

    const [errorData, setErrorData] = useState({});
    
    
    const enterprisesData  =  getEnterprises({userDetails})

    let dashboardModules = getMenuMode?.() == 'new' ? JSON.parse(userDetails?.mainMenu || "{}")?.dashboardModules || [] : JSON.parse(userDetails?.dashboardModules || "[]");
    let availableDashboardModules = ["RDADASH", "RDARSDASHSKX", "SALMNGDASH", "VDVDASHORDV2", "RDVDASHWH", "RDPDASH", "RDVDASHV2", "RDVDASHBOX", "RDVDASHASN", "CSALMNGDASH", "RDPCATDASH", "VDPCATDASH", "RDPDASHMY", "RDFDDASH", "RDTNADASH", "RDTNADASHV2", "VDVDASHBUS"];
    const digiArsStore = useSelector((state) => state.digiArsStore)

    const tabsDataObject = dashboardModules?.reduce((acc, item) => {
        if (availableDashboardModules?.includes(item?.code))
            acc[item.pageUrl] = (parseJwt(sessionStorage?.getItem('token'))?.subUserType == "T" && item?.name == "Order Tracking") ? "Transporter Dashboard" : item?.name;
        return acc;
    }, {});


    const [currentTab, setCurrentTab] = useState(Object?.keys(tabsDataObject || "")?.includes(`#${location.pathname}`) ? `#${location.pathname}` : dashboardModules?.[0]?.pageUrl)
    const [ruleEngineData, setRuleEngineData] = useState([])
    const [newEngineData, setNewEngineData] = useState({})
    const [stripHeight, setStripHeight] = useState(getNumberOfStrips());

    useEffect(() => {
        setInterval(() => {
            setStripHeight(getNumberOfStrips())
        }, 400)
    }, [])

    // handle the response of the new main menu modules
        useEffect(() => {
            if (getNewMainMenuModulesData?.isSuccess) {
                let data = getNewMainMenuModulesData?.data?.resource || {};
                let tokenData = parseJwt(sessionStorage.getItem("token"));
                setUserDetails(prev => {
                    if (tokenData?.vendorOnboardingPage === 1 && tokenData?.eid == -1) {
                        prev["mainMenu"] = JSON.stringify([])
                    } else {
                        prev["mainMenu"] = JSON.stringify(data?.newModuleData || [])
                    }
                    return prev;
                })
            }
    
            if (getNewMainMenuModulesData?.isError) {
                setErrorData(errorData == null ? {} : {})
            }
        }, [getNewMainMenuModulesData])


    // Move to the first available dashboard tab whenever we are sitting on a path that has no
    // matching tab (e.g. the bare /home or /app/product/dashboard/dashboard base path). Runs again
    // once the tabs become available so a slow menu/config load doesn't leave the body empty.
    useEffect(() => {
        const tabKeys = Object.keys(tabsDataObject || {});
        if (location.pathname == "/home" && tabKeys?.[0] && !tabKeys?.includes(`#${location.pathname}`)) {
            history.replace(tabKeys[0]?.replace('#', ''))
        }
    }, [JSON.stringify(Object.keys(tabsDataObject || {})), location.pathname])
    
    // Mapping object for components
    const componentMapping = getMenuMode?.() == 'new' ? {
        '/app/product/cdigisales/dashboard/main' : SalesOrderDashboard,
        '/app/product/allokator/dashboard/main': ArsDashboard,
        '/app/product/allokator/dashboard/performancesummary': PerformanceSummaryDashboard,
        "/app/product/digiproc/dashboard/main": OrderTrackingDashboard,
        '/app/product/digiproc/dashboard/purchase': ProcDashboard,
        "/app/product/digiproc/dashboard/mydashboard": UserDashboard,
        '/app/product/digiproc/dashboard/asnlifecycle': AsnLifecycleDashboard,
        '/app/product/digiproc/dashboard/boxanalysis': BoxAnalysisDashboard,
        '/app/product/digiproc/dashboard/catalogue' : DigicatalogueDashbaord,
        '/app/product/digiproc/dashboard/appointment': WarehouseAppointmentDashboard,
        '/app/product/digisales/dashboard/main': SalesOrderDashboard,
        '/app/product/digivend/dashboard/main': OrderTrackingDashboard,
        '/app/product/digivend/dashboard/catalogue' : DigicatalogueDashbaord,
        // Business Dashboard is a vendor side dashboard, so it lives under digivend
        '/app/product/digivend/dashboard/business': BusinessDashboard,
        // '/app/product/allokator/dashboard/salesforecast': SalesForecastDashboard,
        '/app/product/digiproc/dashboard/tnaAnalysisDashboard': TNAAnalysis,
        '/app/product/digiproc/dashboard/tnaDashboard': TNADashboard,
    } : {
        '/home/ars/new/dashboard': ArsDashboard,
        '/home/sales/dashboard': SalesOrderDashboard,
        '/home/customer/dashboard': SalesOrderDashboard,
        '/home/procurement/dashboard': OldProcDashboard,
        '/home/procurement/dashboard/v2': ProcDashboard,
        '/home/wh/appointment/dashboard': WarehouseAppointmentDashboard,
        '/home/box/analysis/dashboard': BoxAnalysisDashboard,
        '/home/asn/dashboard': AsnLifecycleDashboard,
        "/home/orderTracking/dashboard": OrderTrackingDashboard,
        '/home/vendor/orderTracking/dashboard': OrderTrackingDashboard,
        // Business Dashboard is a vendor side dashboard, so it lives under the vendor path
        //'/home/vendor/business/dashboard': BusinessDashboard,
        '/home/ars/dashboard': PerformanceSummaryDashboard,
        '/home/digicat/dashboard' : DigicatalogueDashbaord,
        "/home/user/dashboard": UserDashboard,
        "/home/tnaAnalysisDashboard": TNAAnalysis,
        "/home/tnaDashboard": TNADashboard,
        // '/home/sales/forecast/dashboard': SalesForecastDashboard,
    };

    useEffect(() => {
        // Update the current tab when user changes the current tab;
        if (Object.keys(tabsDataObject || {})?.some(val => val?.slice(1) == location?.pathname)) {
            let path = Object.keys(tabsDataObject || {})?.find(val => val?.includes(location?.pathname));
            if(currentTab != path){
                if ((getMenuMode?.() == 'new') ? path === '#/app/product/allokator/dashboard/main' : path == "#/home/ars/new/dashboard") {
                    // Call this when user switches to the 
                    getTransferOrderDataRequest()
                }
            }
            setCurrentTab(path);
        }
    }, [location, dashboardModules?.length])

    useEffect(() => {
        if ((getMenuMode?.() == 'new') ? currentTab === '#/app/product/allokator/dashboard/main' : currentTab === '#/home/ars/new/dashboard') {
            dispatchHandler(dispatch, 'getTransferOrderDropdownRequest', { pageNo: 1, search: '', type: 1 }, getPermissionKey("dashboard", "arsdashboard", "view"))
        }
        let path = location?.pathname;
        let moduleName = dashboardModules?.find(item => item?.pageUrl?.includes(path))?.name;
        document.title = (parseJwt(sessionStorage?.getItem('token'))?.subUserType == "T" && moduleName == "Order Tracking") ? "Transporter Dashboard" : moduleName || "Supplymint";
    }, [currentTab])

    // // Function : To get the transfer dropdown data request
    const getTransferOrderDataRequest = () => {
        dispatchHandler(dispatch, 'getArsDashboardRequest', { ruleId: ruleEngineData?.[0]?.id }, getPermissionKey("dashboard", "arsdashboard", "view"))
    }

    useEffect(() => {
        if (digiArsStore?.getTransferOrderDropdownData?.isSuccess && digiArsStore?.getTransferOrderDropdownData?.data?.resource != null) {
            const updatedRuleEngineData = digiArsStore?.getTransferOrderDropdownData?.data?.resource?.ruleEngineData;
            const updatedNewRuleEngineData = updatedRuleEngineData?.find(item => item?.id == searchParams?.get('ruleId')) || updatedRuleEngineData?.[0]            
            
            setRuleEngineData(updatedRuleEngineData)
            setNewEngineData(updatedNewRuleEngineData)
            dispatchHandler(dispatch, 'getArsDashboardRequest', { ruleId: updatedNewRuleEngineData?.id }, getPermissionKey("dashboard", "arsdashboard", "view"))
        }
    }, [digiArsStore?.getTransferOrderDropdownData?.isSuccess])

    // ------------------- UPDATE PROPERTY INSIDE URL SEARCH PARAMS ------------------//
    const updateUrlSearchParams = (config = {}) => {
        let { data = {} } = config;

        // Remove the applied selected items from the URL search params 
        setPayloadAsURLParams({
            data: {
                ...getPayloadFromURLParams({
                    l: location,
                }),
                ...data,
            },
            l: location,
            h: history,
        })
    }   

    const onChangeJobname = (data) => {
        setNewEngineData(data)
        updateUrlSearchParams({
            data : {
                "ruleId" : data?.id
            }
        })
        dispatchHandler(dispatch, 'getArsDashboardRequest', { ruleId: data.id }, getPermissionKey("dashboard", "arsdashboard", "view"))
    }

    const renderDashboardTopRightComponent = () => {
        switch (currentTab) {
            case '#/app/product/allokator/dashboard/main':
            case "#/home/ars/new/dashboard":
                return <GenericInput
                    type="dropdown"
                    iconRight={<Icons.DownArrowNew />}
                    inputKey="jobname"
                    placeholder='Rule Engine'
                    value={ruleEngineData?.find(item => item?.jobname ==  newEngineData?.jobname)?.display_name || ""}
                    onChange={(item) => onChangeJobname(item)}
                    inputProps={() => {
                        return {
                            headerKeys: {
                                "display_name": {
                                    value: "jobname",
                                    width: "100%"
                                },
                            },
                            "itemKeys": {
                                "display_name": ["display_name"]
                            },
                            "getListData": () => {
                                return ruleEngineData || [];
                            },
                        }
                    }}
                />
        }
    }

    return (<>
        {(enterprisesData?.length != 0 && enterprisesData?.[0]?.eid == -1 || enterprisesData?.[0]?.oid == -1 && uType === "VENDOR") ?
            <NewRegisterVendorDashbaord {...props} />
            :
            <React.Fragment>
                <div className={`dashboard-tab top-${stripHeight + 45}`}>
                    <GenericTabsComponent
                        tabsData={tabsDataObject || {}}
                        className="p-lr-47"
                        borderDown={true}
                        tabsKey={"currentTab"}
                        handleTabChange={(val) => {
                            setCurrentTab(val);
                            if ((getMenuMode?.() == 'new') ? val == '#/app/product/allokator/dashboard/main' : val == "#/home/ars/new/dashboard") {
                                // Call this when user switches to the 
                                getTransferOrderDataRequest()
                            }

                            history.push(val?.replace(/^#/, ''))
                        }}
                        current={currentTab}
                        type={1}
                    />

                    {renderDashboardTopRightComponent()}
                </div>
                <Switch>
                    {Object.keys(componentMapping || {}).map(url => {
                        return (
                            <Route
                                key={url}
                                exact
                                path={url}
                                render={(props) => {
                                    const Component = componentMapping?.[url];
                                    return <Component jobName={newEngineData?.jobname} newEngineData={newEngineData} />;
                                }}
                            />
                        );
                    })}
                    {Object.keys(tabsDataObject || {})?.length == 0 ? <Route key={"defaultDashboard"} path={getMenuMode?.() == "new" ? "/app" : "/home"} render={(props) => {return <HomeDashboard/>}}/> : null}
                </Switch>
            </React.Fragment>
        }
    </>
    )
}

export default Dashboard